(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["animia-sales-carousel"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const carousels = document.querySelectorAll('[data-animia-sales-carousel]');

    carousels.forEach((carousel) => {
      const track = carousel.querySelector('[data-animia-carousel-track]');
      const slides = Array.from(carousel.querySelectorAll('.animia-sales-carousel__slide'));
      const dots = Array.from(carousel.querySelectorAll('[data-animia-carousel-dot]'));
      const previous = carousel.querySelector('[data-animia-carousel-prev]');
      const next = carousel.querySelector('[data-animia-carousel-next]');
      const autoplay = carousel.dataset.autoplay === 'true';
      const autoplaySpeed = Number(carousel.dataset.autoplaySpeed || 5000);
      let activeIndex = 0;
      let interval = null;

      if (!track || slides.length <= 1) {
        return;
      }

      const setActive = (index) => {
        activeIndex = Math.max(0, Math.min(index, slides.length - 1));

        dots.forEach((dot, dotIndex) => {
          dot.classList.toggle('is-active', dotIndex === activeIndex);

          if (dotIndex === activeIndex) {
            dot.setAttribute('aria-current', 'true');
          } else {
            dot.removeAttribute('aria-current');
          }
        });
      };

      const goTo = (index) => {
        const nextIndex = (index + slides.length) % slides.length;
        const slide = slides[nextIndex];

        track.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
        setActive(nextIndex);
      };

      const restartAutoplay = () => {
        if (!autoplay) {
          return;
        }

        window.clearInterval(interval);
        interval = window.setInterval(() => goTo(activeIndex + 1), autoplaySpeed);
      };

      dots.forEach((dot) => {
        dot.addEventListener('click', () => {
          goTo(Number(dot.dataset.animiaCarouselDot));
          restartAutoplay();
        });
      });

      previous?.addEventListener('click', () => {
        goTo(activeIndex - 1);
        restartAutoplay();
      });

      next?.addEventListener('click', () => {
        goTo(activeIndex + 1);
        restartAutoplay();
      });

      track.addEventListener(
        'scroll',
        () => {
          const index = Math.round(track.scrollLeft / track.clientWidth);
          setActive(index);
        },
        { passive: true }
      );

      carousel.addEventListener('mouseenter', () => window.clearInterval(interval));
      carousel.addEventListener('mouseleave', restartAutoplay);
      carousel.addEventListener('focusin', () => window.clearInterval(interval));
      carousel.addEventListener('focusout', restartAutoplay);
      restartAutoplay();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
